export const DEFAULT_WIDTH = 400
